import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { closeModal } from "../../redux/features/modalSlice";

import { } from "../../redux/services/stateService/state.Services";

import { useGetStateQuery } from "../../redux/services/stateService/state.Services";

import { useUpdateCityMutation } from "../../redux/services/cityService/city.Services";

import { successToast, errorToast } from "../../Utils/toast";

function EditCity({ data }) {
  const dispatch = useDispatch();
  const { data: stateResponse } = useGetStateQuery();

  const stateData = stateResponse?.data || [];

  const [updateCity, { isLoading }] = useUpdateCityMutation();

  const [formData, setFormData] = useState({
    id: data?.id,
    name: data?.name,
    state_id: String(data?.state_id || ""),
    status: data?.status,
  });

  // HANDLE CHANGE
  const handleInputChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // UPDATE CITY
  const handleUpdateCity = async () => {
    try {
      const response = await updateCity(formData).unwrap();
      successToast(response?.message);

      dispatch(closeModal());

    } catch (error) {

      console.log(error);

      errorToast(
        error?.data?.message || "Update Failed"
      );
    }
  };

  return (
    <>

      {/* BODY */}
      <div className="custom-modal-body">

        <div className="model-custum">
          <div className="edit-form-group">
            <label>
              City Name
            </label>

            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="form-control"
            />

          </div>

          {/* STATE */}
          <div className="edit-form-group">

            <label>
              State Name
            </label>

            <select
              name="state_id"
              value={formData.state_id}
              onChange={handleInputChange}
              className="form-control"
            >

              {
                stateData.map((item) => (

                  <option
                    key={item.id}
                    value={String(item.id)}
                  >
                    {item.name}
                  </option>

                ))
              }

            </select>

          </div>

          {/* STATUS */}
          <div className="edit-form-group">

            <label>
              Status
            </label>

            <select
              name="status"
              value={formData.status}
              onChange={handleInputChange}
              className="form-control"
            >
              <option value="active">
                Active
              </option>
              <option value="inactive">
                Inactive
              </option>

            </select>

          </div>

        </div>

      </div>

      {/* BUTTONS */}
      <div className="modal-btn-group">

        <button
          className="cancel-btn"
          onClick={() => dispatch(closeModal())}
        >
          Cancel
        </button>

        <button
          className="save-btn"
          onClick={handleUpdateCity}
        >

          {
            isLoading
              ? "Loading..."
              : "Save Changes"
          }

        </button>

      </div>

    </>
  );
}

export default EditCity;